/**
 * Config templates store — list of available templates with fixture fallback.
 */
import { create } from "zustand";
import { get as apiGet, ApiError } from "@/api/client";
import { ConfigTemplateListSchema, type ConfigTemplate } from "@/api/schemas/config-templates";
import { MOCK_CONFIG_TEMPLATES } from "@/api/fixtures/config-templates";

interface State {
  data: ConfigTemplate[];
  status: "idle" | "loading" | "ready" | "error";
  error: string | null;
  load: () => Promise<void>;
}

export const useConfigTemplates = create<State>((set, get) => ({
  data: [],
  status: "idle",
  error: null,
  load: async () => {
    if (get().status === "loading") return;
    set({ status: "loading", error: null });
    try {
      const raw = await apiGet<unknown>("/config/templates/");
      set({ data: ConfigTemplateListSchema.parse(raw), status: "ready" });
    } catch (err) {
      const message =
        err instanceof ApiError
          ? `API error ${err.status}`
          : err instanceof Error
            ? err.message
            : "unknown error";
      set({
        data: MOCK_CONFIG_TEMPLATES,
        status: "error",
        error: `${message} — showing fixture data`,
      });
    }
  },
}));
